import { render, staticRenderFns } from "./WidgetWall.vue?vue&type=template&id=5fce7fe8"
import script from "./WidgetWall.vue?vue&type=script&lang=js"
export * from "./WidgetWall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports